/*eslint-disable*/
import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllModules } from "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-enterprise";
import { Link } from 'react-router-dom'
import { LicenseManager } from 'ag-grid-enterprise';
import CustomNoRowsOverlay from "./customNoRowsOverlay";
import TitleBar from "../titleBar/title_bar";
import { Button, Icon, Input, Segment, Header } from "semantic-ui-react";
import ImportModal from '../commonComponent/importModal';
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
LicenseManager.setLicenseKey('Elixia_Tech_Solutions_Ltd_MultiApp_1Devs16_March_2019__MTU1MjY5NDQwMDAwMA==c4c29e5702e62789dbdb799433c73545')

class AgGridTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modules: AllModules,
      defaultColDef: {
        flex: 1,
        minWidth: 100,
        enableValue: true,
        enableRowGroup: true,
        enablePivot: true,
        resizable: true,
      },
      openImportModal: false,
      sideBar: {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
          },
          {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel",
          },
        ],
        defaultToolPanel: "",
      },
      isLoading: true,
      rowData: [],
      frameworkComponents: {
        actionRenderer: props.actionButton,
        customNoRowsOverlay: CustomNoRowsOverlay,
        ...props.extraComponents
      },
      noRowsOverlayComponent: "customNoRowsOverlay",
      noRowsOverlayComponentParams: {
        noRowsMessageFunc: function () {
          return "No Record(s) Found";
        },
      },
    };
  }
  getParams() {
    return {
      columnGroups: true,
      fileName: this.props.titleBarTitle,
    };
  }
  onBtnExportDataAsExcel = () => {
    var params = this.getParams();
    this.gridApi.exportDataAsExcel(params);
  };
  importDataGrid = () => {
    console.log("import the data grid");
  };
  filterChanged = (e) => {
    if (this.gridApi.getDisplayedRowCount() === 0) {
      this.gridApi.showNoRowsOverlay();
    } else {
      this.gridApi.hideOverlay();
    }
  };
  onGridReady = (prams) => {
    this.gridApi = prams.api;


    this.setState({
      isLoading: this.props.isLoading,
    });


    //AutoSize Columns Onload
    this.gridColumnApi = prams.columnApi;

    var allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    })
    this.gridColumnApi.autoSizeColumns(allColumnIds);

    // if (this.props.sizeColumnsToFit) prams.api.sizeColumnsToFit();
  };
  exportDataGrid = (data) => {
    if (data) {
      let keys = []
      this.props.columnDefs.forEach(element => {
        element.field != "edit" && keys.push(element.headerName)
      });
      // console.log(keys)
      let param = {
        fileName: this.props.titleBarTitle,
        allColumns: true
      };
      this.gridApi.exportDataAsExcel(param);
    }
  };

  openImportModal = () => {
    this.setState({ openImportModal: true });
  };

  handleImportClose = () => {
    this.setState({ openImportModal: false });
  }

  render() {

    return (
      <>
        <TitleBar approvals={this.props.approvalsSection} title={this.props.titleBarTitle} hiddenNew={this.props.hiddenNew} LinkName={this.props.link}>
          <Input size="mini" icon={{ name: 'search', circular: true }} onChange={this.props.handleSearch} className="mr-1 searchInput" placeholder="Search..." />


          {this.props?.showImport && this.props?.showImport == true
            ?
            <Button size="tiny" onClick={this.openImportModal} basic color="facebook" icon><i className="icon"><img alt="Import" src="assets/svg/import.svg" /></i> Import</Button>
            :
            null
          }

          <Button size="tiny" hidden={this.props.exportHidden} onClick={this.exportDataGrid} basic color="facebook" icon><i className="icon"><img alt="Export" src="assets/svg/export.svg" /></i> Export</Button>
          <Button disabled={this.props.titleBarTitle == 'Categories' || this.props.titleBarTitle == 'Jobcard Type'} hidden={this.props.hiddenNewPopupBtn} onClick={this.props.newPopup} size="tiny" basic color="blue" icon><Icon name="plus" /> New</Button>
          <Button as={Link} to={this.props.importLink && this.props.importLink} hidden={this.props.hiddenImportPopupBtn} size="tiny" basic color="facebook" icon><i className="icon"><img alt="import" src="assets/svg/import.svg" /></i> Import</Button>
        </TitleBar>

        {(!this.props.rowData || this.props.rowData?.length === 0) && this.props.isLoading ?
        <LoadingPlaceholder /> : 
        (!this.props.rowData || this.props.rowData?.length === 0 ? 
        <Segment className="m-2">
          <center> <Header>NO Record(s) Found</Header></center>
        </Segment>
        :
          <div className="ag-theme-material agOver">
            <AgGridReact
              domLayout="autoHeight"
              modules={this.state.modules}
              sideBar={this.state.sideBar}
              rowGroupPanelShow={"always"}
              quickFilterText={this.props.searchValue}
              suppressAutoSize={true}
              columnDefs={this.props.columnDefs}
              defaultColDef={this.state.defaultColDef}
              frameworkComponents={this.state.frameworkComponents}
              rowSelection="multiple"
              noRowsOverlayComponent={this.state.noRowsOverlayComponent}
              noRowsOverlayComponentParams={this.state.noRowsOverlayComponentParams}
              rowData={this.props.rowData}
              pagination={this.props.pagination || true}
              baseURL={this.props.baseURL}
              paginationPageSize={this.props.limit || 10}
              onPaginationChanged={this.props.onPaginationChanged || ""}
              onGridReady={this.onGridReady}
              exportBtn={this.exportDataGrid}
              onFilterChanged={this.filterChanged}
              onRowSelected={this.props.rowSelected}
              {...this.props}
            />
          </div>)
        }


        <ImportModal
          openBox={this.state.openImportModal}
          handleClose={this.handleImportClose}
          {...this.props}
        />
      </>
    );
  }
}

export default AgGridTable;